export default __webpack_public_path__ + "assets/images/6275bcef07d7e9fc3b8ba88748e76a8d.png";